import { ActivityType } from './connections';

export enum GaugeUnits {
  METER_PER_HOUR = 'm/h',
  JOINT_PER_HOUR = 'jts/h',
  STAND_PER_HOUR = 'stds/h',
}

export interface OperationBcwWellInformation {
  well_id: string;
  well_name: string;
}

export interface GaugeApiResponse {
  gauge_type: ActivityType;
  gauge_min_bound: number | null;
  gauge_max_bound: number | null;
  gauge_low_area_upper_limit: number | null;
  gauge_mid_area_upper_limit: number | null;
  operation_avg_value: number | null;
  operation_bcw_value: number | null;
  operation_current_value: number | null;
  operation_bcw_well_information: OperationBcwWellInformation;
  operation_uom: GaugeUnits;
}
